import "../SystemPreferences.scss";

const StorePatientEncounterDataTooltip = (): JSX.Element => (
  <div className="store-patient-encounter-data-tooltip">
    <p>Patient encounter data is used by the application for two purposes:</p>
    <ul>
      <li>Integrating data coming from the customer’s system;</li>
      <li>Patient encounter recovery.</li>
    </ul>
    <p>The In-Memory Cache option ensures data is never written to disk.</p>
    <p>
      The Azure SQL Database option physically stores the patient encounter data in the TruBridge
      Encoder database.
    </p>
    <p>Please see the TruBridge Encoder Help for additional information.</p>
  </div>
);

export default StorePatientEncounterDataTooltip;
